import { NodeData } from './../codeBlocks/NodeData';
import { CustomNode } from './../codeBlocks/CustomNode';
import { DiagramSchema, Link } from "beautiful-react-diagrams/@types/DiagramSchema";

const FIRST_COORDINATE: [number, number] = [150, 60]; // coordinate of the first node
const NEXT_X: number = 150; // value to add to last x coordinate for the next node

export class CustomSchema implements DiagramSchema<NodeData>{
    nodes: CustomNode[];
    links: Link[];

    constructor() {
        this.nodes = [];
        this.links = [];
    }

    /**
     * Returns the coordinates for the next node. If no node exists it will return FIRST_COORIDNATE If a node
     * exists, it will return NEXT_X more x value of the last node in schema. 
     */
    getNextCoordinates(): [number, number] {
        if (this.nodes == null || this.nodes.length === 0) {
            return FIRST_COORDINATE;
        }
        return [
            this.nodes[this.nodes.length - 1].coordinates[0] + NEXT_X,
            this.nodes[this.nodes.length - 1].coordinates[1]
        ]
    }

    

}